import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RxIconModule } from '@nrwl/rx-icon';

import { ScribeSuggestionMarkerTarget } from '../../../scribe-suggestion-marker.model';
import { isScribeSuggestionMarked } from '../../../scribe-suggestion-marker.util';

export type ScribeSuggestionIndicatorVariant = 'full' | 'compact';

@Component({
  selector: 'fb-scribe-suggestion-indicator',
  standalone: true,
  imports: [MatTooltipModule, RxIconModule],
  templateUrl: './scribe-suggestion-indicator.component.html',
  styleUrl: './scribe-suggestion-indicator.component.scss',
  host: {
    '[class.visible]': 'visible',
    '[class.compact]': 'variant === "compact"',
  },
})
export class ScribeSuggestionIndicatorComponent {
  @Input() target: ScribeSuggestionMarkerTarget | null | undefined;
  @Input() fieldKey?: string;
  @Input() fieldKeys?: string[];
  @Input() variant: ScribeSuggestionIndicatorVariant = 'full';

  public get visible(): boolean {
    if (this.fieldKeys?.length) {
      return this.fieldKeys.some((fieldKey) => isScribeSuggestionMarked(this.target, fieldKey));
    }

    return isScribeSuggestionMarked(this.target, this.fieldKey);
  }
}
